import { useMemo } from 'react';
import * as Progress from '@radix-ui/react-progress';
import { useChecklistData } from 'components/required-checklist/useChecklistData';

const RequiredChecklistProgressBar = () => {
    const { checklist } = useChecklistData();
    const progress = useMemo(() => {
        const values = Object.values(checklist);
        return Math.round((values.filter(value => value).length / values.length) * 100);
    }, [checklist]);

    return (
        <div className="flex h-5 items-end gap-3">
            <Progress.Root
                value={progress}
                className={'h-2 w-full overflow-hidden rounded-full bg-gray-200'}
            >
                <Progress.Indicator
                    style={{ transform: `translateX(-${100 - Math.max(progress, 3)}%)` }}
                    className={`bg-success-500 h-full rounded-full transition-transform duration-500`}
                />
            </Progress.Root>
            <p className="text-sm font-medium leading-3">{progress}%</p>
        </div>
    );
};

export { RequiredChecklistProgressBar };
